import React from 'react';
import { styles } from './trainAgentStyles';

export function TrainAgentSaveBar({ vm }) {
  const { handleSave, saving } = vm;
  return (
    <div style={{ marginTop: '24px' }}>
      <button type="button" onClick={handleSave} style={styles.button} disabled={saving}>
        {saving ? 'Salvando...' : 'Salvar treino'}
      </button>
    </div>
  );
}
